<div class="container">

    <div class="row">
    
      <div class="col-md-12">
        <div class="main-card mb-3 card">
          <div class="card-header font-weight-B fs-1r">Upload CSV</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-1" ></div>
              <div class="col-md-4">
                <label for="">Vehicle Info :</label>
                <div class="imageMainDiv">
                    <label for="inputTag">
                      Upload CSV File For Vehicles <br/>
                      <img src="../../assets/images/csv.png"  height="90px" alt="">
                      <input id="inputTag" type="file" class="input_file"  (change)="getCSV_vehicle($event)"  />
                      <br/>
                      <span id="imageName"></span>
                    </label>
                    <div *ngIf="vehicleUploadStatus"><span class="text-success">File Loaded</span></div>
                  </div> 
                  <div class="text-center">
                    <button [disabled]="  vehicleMainData == ''" class="btn-wide mb-2 mt-4  me-2 btn btn-primary" (click)="uploadVehicle()">Upload</button>
                  </div>
              </div>
              <div class="col-md-2"></div>
              <div class="col-md-4">
                <label for="">Package Info :</label>
                <div class="imageMainDiv">
                    <label for="inputTag1">
                      Upload CSV File For Packages <br/>
                      <img src="../../assets/images/csv.png"  height="90px" alt="">
                      <input id="inputTag1" type="file" class ="input_file"  (change)="getCSV_package($event)"  />
                      <br/>
                      <span id="imageName"></span>
                    </label>
                    <div *ngIf="packageUploadStatus"><span class="text-success">File Loaded</span></div>

                  </div>
                  <div class="text-center">
                    <button [disabled]="packageMainData == ''" class="btn-wide mb-2 mt-4  me-2 btn btn-primary" (click)="uploadPackage()">Upload</button>
                  </div>
              </div>
              <div class="col-md-1" ></div>
            </div>
      
          </div>
        </div>
      </div>
    
          </div>
    
    
    
    
    
    
    </div>
  
 